import React from "react";
import { CheckIcon, ChipIcon } from "@heroicons/react/solid";
import { skills } from "../data";

// Shares the token system used in Projects.jsx
// bg #0B0D12   surface #12151B   border #232733
// text #EDEFF3   muted #8D93A3   accent-1 #9C8CFF (violet)   accent-2 #5FD9C4 (teal)

export default function Skills() {
  return (
    <section id="skills" className="bg-[#0B0D12] text-[#8D93A3]">
      <div className="container mx-auto px-6 py-24 lg:px-8 max-w-6xl">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 rounded-md border border-[#232733] bg-[#12151B]">
            <span className="w-2 h-2 rounded-full bg-[#5FD9C4]" />
            <span className="font-mono text-xs tracking-wide text-[#8D93A3]">
              skills.json
            </span>
          </div>

          <ChipIcon className="w-8 h-8 mx-auto mb-4 text-[#8D93A3]" />
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#EDEFF3] mb-4">
            Skills &amp; technologies
            <span className="inline-block w-[10px] h-[1.9rem] bg-[#9C8CFF] ml-2 align-middle animate-[blink_1.1s_steps(1)_infinite]" />
          </h2>
          <p className="text-base leading-relaxed max-w-2xl mx-auto text-[#8D93A3]">
            Driving frontend development excellence with advanced skills and
            technologies — delivering engaging interfaces and high-performance
            web solutions for the modern digital landscape.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 lg:gap-4 max-w-4xl mx-auto">
          {skills.map((skill, index) => (
            <div
              key={index}
              className="group flex items-center gap-4 rounded-lg border border-[#232733] bg-[#12151B] px-5 py-4 transition-colors duration-300 hover:border-[#5FD9C4]/50"
            >
              <span className="flex items-center justify-center w-6 h-6 flex-shrink-0 rounded-full border border-[#5FD9C4]/40 bg-[#5FD9C4]/10">
                <CheckIcon className="w-3.5 h-3.5 text-[#5FD9C4]" />
              </span>

              <span className="font-medium text-[#EDEFF3]">
                {skill.skilly}
              </span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes blink { 50% { opacity: 0; } }
      `}</style>
    </section>
  );
}